import { Injectable } from '@angular/core';
import { BaseService, E8HttpClient, C8HttpClientOptions } from '../../../../core';
import { DynamicComponentGetSelectMetaInfoRequest } from './model/dynamicComponentGetSelectMetaInfoRequest';
import { DynamicComponentGetSelectMetaInfoResponse } from './model/dynamicComponentGetSelectMetaInfoResponse';
@Injectable()
export class DynamicComponentSelectService extends BaseService {
  private getPage_URL = 'metabase/dynamicComponent/getSelectMetaInfo';

  constructor(private client: E8HttpClient) {
    super();
  }

  getSelectMetaInfo(request: DynamicComponentGetSelectMetaInfoRequest,moduleName?:string, options?: C8HttpClientOptions): Promise<DynamicComponentGetSelectMetaInfoResponse> {
    return this.client.post(this.fUrl(this.getPage_URL,moduleName), request, options);
  }
}
